export type MentorLifecycleStatus = 'draft' | 'published' | 'paused';

export function mentorLifecycleStatus(status: string): MentorLifecycleStatus {
  if (status === 'published' || status === 'active') return 'published';
  if (status === 'paused' || status === 'suspended') return 'paused';
  return 'draft';
}
